import { midiToNote, Note, noteToMidi } from "./notes";
import { Range } from "./ranges";

export enum VocalRegister {
  Full = "full",
  Chest = "chest",
  Break = "break",
  Head = "head",
}

export function isVocalRegistor(value: string): value is VocalRegister {
  return Object.values(VocalRegister).includes(value as VocalRegister);
}

export function getAllRegisterRangesFromRange(range: {
  low: Note;
  high: Note;
}): {
  [key in VocalRegister]: Range;
} {
  function ensureNotHigherThanHigh(value: number) {
    return Math.min(value, high);
  }

  function ensureNotLowerThanLow(value: number) {
    return Math.max(value, low);
  }

  function safelyMakeRange(low: number, high: number): Range {
    high = ensureNotLowerThanLow(high);

    return {
      range: "custom",
      low: midiToNote(low),
      high: midiToNote(high),
    };
  }

  const low = noteToMidi(range.low);
  const high = noteToMidi(range.high);

  // Chest starts  bottom 55% of range
  const lowChest = low;
  const highChest = ensureNotHigherThanHigh(
    low + Math.floor((high - low) * 0.55)
  );

  // Start at 33% of range
  const lowMixed = ensureNotLowerThanLow(
    low + Math.floor((high - low) * 0.333)
  );
  // End at 66% of range
  const highMixed = ensureNotHigherThanHigh(
    low + Math.floor((high - low) * 0.666)
  );

  // Head starts at top 45% of range
  const lowHead = ensureNotLowerThanLow(low + Math.floor((high - low) * 0.45));
  const highHead = high;

  return {
    [VocalRegister.Chest]: safelyMakeRange(lowChest, highChest),
    [VocalRegister.Break]: safelyMakeRange(lowMixed, highMixed),
    [VocalRegister.Head]: safelyMakeRange(lowHead, highHead),
    [VocalRegister.Full]: safelyMakeRange(low, high),
  };
}
